import { Axios } from 'axios';
import { CONTROLLER_API_PREFIX, UNI_API_CONTROLLER } from 'app/constants';
import type { AgreementsResponse } from 'app/domain';

class AgreementsService {
  readonly #httpClient: Axios;
  readonly #baseUrl: string;

  constructor(httpClient) {
    this.#httpClient = httpClient;
    this.#baseUrl = `/${CONTROLLER_API_PREFIX}/${UNI_API_CONTROLLER.agreements}`;
  }

  // No parameters: the agreements a user holds do not depend on the search.
  async get(): Promise<AgreementsResponse> {
    const response = await this.#httpClient.get(this.#baseUrl);

    return response.data;
  }
}

export default AgreementsService;
